<footer class="text-lg-start">
  <div *ngIf="showTopFooter" class="top-footer">
    <!-- Grid container -->
    <div class=" container p-4">
      <!--Grid row-->
      <div class="row">
	<!-- Grid column -->

	   <div class="col-lg-2 col-md-2 mb-2 mb-lg-0">
		      <h6> EU Funded</h6> 
		      <!--   <a href="https://commission.europa.eu/education/set-projects-education-and-training/erasmus-funding-programme_en" target="_blank" class="image-link" > -->
		      <img src='assets/images/EUcfnd_200.jpg' alt="EU Funded" >
	  
	</div>
        <!--Grid column-->
        <div class="col-lg-2 col-md-2 mb-2 mb-lg-0">
          <h6>Romania</h6>
	  <!--  <a  href="https://openup.gr" target="_blank" class="image-link" > -->
          <img src='assets/images/Romania_200.jpg' alt="Romania" >
	  
	  <!--
	  <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Lorem ipsum</a>
            </li>
            <li>
              <a routerLink="./" class="">Ut facilisis</a>
            </li>
            <li>
              <a routerLink="./" class="">Aenean sit</a>
            </li>
          </ul>
	  -->
        </div>
        <!--Grid column-->
	  <div class="col-lg-2 col-md-2 mb-2 mb-lg-0">
          <h6>Spain</h6>
	  <!--  <a href="http://www.cristocrucificadomula.es/" target="_blank" class="image-link"> -->
          <img src='assets/images/Spain_200.jpg' alt="Spain" >
	  
	  <!-- <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Suspendisse potenti</a>
            </li>
	  </ul> -->
        </div>
        <!--Grid column-->
        <div class="col-lg-2 col-md-2 mb-2 mb-lg-0">
          <h6>Turkey</h6>
	  <!--  <a href="https://kayseribilsem.meb.k12.tr/" target="_blank" class="image-link"  > -->
          <img src='assets/images/Turkey_200.jpg' alt="Turkey" >
	  
	  <!--
          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Suspendisse potenti</a>
            </li>
          </ul>
	  -->
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-2 col-md-2 mb-2 mb-md-0">
		<h6>Italy</h6>
		<!-- <a href="http://icandreottipescia.edu.it/" target="_blank" class="image-link"  > -->
          <img  src='assets/images/Libero_Andreotti_200.jpg' alt="Italy" >
		
	</div>
        <!--Grid column-->
      </div>
      <div class="row mt-2">
       <div class="m-0 mx-auto">
        S2CF by <img src="./assets/images/OpenUp_logo200.png" alt="OpenUp logo ">


        <a href="http://www.openup.gr/"> OpenUp</a> Greek Scientific Association of Innovation, copyright <span>&copy;</span> 2023
       </div>

      </div> <!-- My row -->


      <!--Grid row-->
    </div>
  </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="bottom-footer p-1 d-flex justify-content-center align-items-center text-white">
    <div class="content-container">
      <p class="m-0">
        <a class="text-white"
           href="http://www.dspace.org/">{{ 'footer.link.dspace' | translate}}</a>
        {{ 'footer.copyright' | translate:{year: dateObj | date:'y'} }}
        <a class="text-white"
           href="https://www.lyrasis.org/">{{ 'footer.link.lyrasis' | translate}}</a>
      </p>
      <ul class="footer-info list-unstyled small d-flex justify-content-center mb-0">
        <li>
          <a class="text-white" href="javascript:void(0);"
             (click)="showCookieSettings()">{{ 'footer.link.cookies' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/feedback">{{ 'footer.link.feedback' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- Copyright -->
</footer>
